import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useVendorListings } from 'app/utils/api/queries';
import listingsSlice from 'app/store/listings/listings.slice';
import userSlice from 'app/store/user/user.slice';
import STORAGE_CONSTANTS from 'app/constants/storage';
import Storage from 'app/utils/storage/local';

export const useInitializeListingSelection = () => {
    const { user, isAuthenticated } = userSlice();
    const { data } = useVendorListings();
    const { currentListingSelection, setCurrentListing, setListing } = listingsSlice();
    const [searchParams, setSearchParams] = useSearchParams();
    const listingFromParam = searchParams.get('listing');
    const storageKey = `${STORAGE_CONSTANTS.currentListing}.${user?.email}`;
    const savedListing = Storage.get(storageKey);

    useEffect(() => {
        if (!isAuthenticated || !user.pk || data === undefined) return;

        const requestedListing = data.find((listing) => listing.pk === Number(listingFromParam));
        const storedListing = data.find((listing) => listing.pk === Number(savedListing));
        const currentListing = data.find((listing) => listing.pk === currentListingSelection);
        const listing = requestedListing || currentListing || storedListing || data[0];

        if (savedListing && !storedListing) Storage.remove(storageKey);
        if (!listing) return;

        if (listing.pk !== currentListingSelection) setCurrentListing(listing.pk);
        setListing(listing);

        if (listingFromParam) {
            searchParams.delete('listing');
            setSearchParams(searchParams, { replace: true });
        }
    }, [
        isAuthenticated,
        user.pk,
        data,
        currentListingSelection,
        listingFromParam,
        savedListing,
        storageKey,
        searchParams,
        setSearchParams,
        setCurrentListing,
        setListing,
    ]);
};
